import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { RecommendationService } from '../shared/services/recommendation.service';
import { PriceRecommenderService } from '../shared/services/price-recommender.service';
import * as constant from './../shared/constants/constants';
import { UtilService } from '../shared/services/util.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {

  dataSource:any = new MatTableDataSource()
  displayedColumns: any =[]
  price_band_data: any =[]
  price_band_configuration_data : any = [];
  save_configuration : any =[]

  constructor(public service: PriceRecommenderService, public utilService: UtilService){}

  ngOnInit(){
    this.getPriceBandConfigurationData()
    this.getPriceBandData();
  }
  
  /** Service Call to Get All Price Bands */
  getPriceBandData(){
    this.service.getPriceBandConfigDropdown().subscribe((response)=>{
      this.price_band_data = response;
    })
  }

  /** Create DTO after Drodpdown Change */
  OnPriceBandChange(value:any){
    const existingIndex = this.save_configuration.findIndex(
      (item: any) => item.geo_source_id === value.geo_source_id
    );
    if (existingIndex !== -1) {
      this.save_configuration[existingIndex].geo_elasticity_destination_id = value.geo_elasticity_destination_id;
    } else {
      this.save_configuration.push({
        geo_source_id: value.geo_source_id,
        geo_elasticity_destination_id: value.geo_elasticity_destination_id
      });
    }
  }

  /** Save Change Api Call */
  onSavePriceBandConfiguration(){
    this.service.savePriceBandConfig(this.save_configuration).subscribe((response:any)=>{
      this.save_configuration = []
      this.getPriceBandConfigurationData();
    })
  }

  /** Get Existing Configuration */
  getPriceBandConfigurationData(){
    this.service.getPriceBandConfig().subscribe((response:any)=>{
      this.price_band_configuration_data = response.map((value:any)=>{
        value['original_geo_elasticity_destination_id'] = value.geo_elasticity_destination_id;
        return value
      });
      this.dataSource = new MatTableDataSource(this.price_band_configuration_data)
      this.displayedColumns = constant.settings.columnData;
    })
  }

  /** On Click Of Cancel Clear the Dropdowns */
  onCancel(){
    const geoSourceIds = new Set(this.save_configuration.map((item: any) => item.geo_source_id));
    this.price_band_configuration_data.forEach((value:any)=>{
      if (geoSourceIds.has(value.geo_source_id)) {
        value.geo_elasticity_destination_id = value.original_geo_elasticity_destination_id;
      }
    })
    this.dataSource = new MatTableDataSource(this.price_band_configuration_data)
    this.save_configuration = [];
  }
}
